import { NOTARY_BAD_REQUEST_API_I18N } from "./commonUiI18nNotaryBadRequestCatalog";
import { workspaceDemonstrativeTarget } from "@Front/Utils/publicSiteBranding";

/** Sous-arbre `folderMessages` — extrait de `commonUiI18nPart1_sliceC` pour respecter max-lines. */
export const FOLDER_MESSAGES_NOTARY_API_VALIDATION_GROUP = {
	/** Codes API (le-coffre-resources) → message notaire. */
	thirdPartyNotaryApiValidation: {
		THIRD_PARTY_EMAIL_REQUIRED: "L'adresse email du tiers est obligatoire pour créer ou lier le contact.",
		THIRD_PARTY_CONTACT_UID_NOT_FOUND:
			"Le contact indiqué est introuvable. Vérifiez l'identifiant ou créez le tiers sans lier un contact existant.",
		THIRD_PARTY_CONTACT_UID_EMAIL_MISMATCH:
			"L'identifiant de contact ne correspond pas à l'email saisi. Utilisez le même email que celui du carnet de contacts.",
		THIRD_PARTY_DUPLICATE_IN_FOLDER_OFFICE:
			"Un tiers avec ce contact ou cet email est déjà rattaché à ce dossier pour votre étude.",
		OFFICE_EMAIL_THIRD_PARTY_BLOCKED_BY_CUSTOMER:
			"Cet email est déjà utilisé par un client sur ce dossier. Retirez le client de ce dossier, ou ajoutez le tiers sur un autre dossier (onglet Participants → Tiers).",
		OFFICE_EMAIL_CUSTOMER_DUPLICATE: "Cette adresse email est déjà enregistrée comme client sur un dossier de l'étude.",
		OFFICE_EMAIL_CUSTOMER_BLOCKED_BY_THIRD_PARTY:
			"Cet email est déjà utilisé par un tiers sur un dossier de l'étude. Utilisez une autre adresse pour le client.",
		OFFICE_EMAIL_THIRD_PARTY_BLOCKED_BY_OTHER_FOLDER:
			"Un tiers avec cet email existe déjà sur un autre dossier de l'étude. Ce cas peut être bloqué selon le parcours.",
		OFFICE_EMAIL_FOLDER_SHARING_INVITED_EMAIL_CONFLICT:
			"Cet email est déjà utilisé comme client ou tiers sur ce dossier. Utilisez une autre adresse pour inviter le confrère.",
	},
	folderSharingNotaryApiValidation: {
		FOLDER_SHARING_DUPLICATE_ACTIVE: `Un partage existe déjà pour ce dossier, ${workspaceDemonstrativeTarget()} et ce notaire invité.`,
		FOLDER_SHARING_SELF_INVITE_NOT_ALLOWED: "Vous ne pouvez pas vous inviter vous-même en tant que notaire invité.",
		FOLDER_SHARING_SAME_OFFICE_INVITE_NOT_ALLOWED:
			"Vous ne pouvez pas inviter un notaire de votre propre cabinet en tant que notaire invité. Veuillez choisir un notaire d'un autre cabinet.",
		FOLDER_SHARING_INVITED_OFFICE_IDNOT_REQUIRED:
			"Sélectionnez l'étude du confrère dans l'annuaire IdNot avant d'envoyer l'invitation.",
		FOLDER_SHARING_INVITED_OFFICE_ANNUAIRE_UNRESOLVED:
			"L'étude IdNot sélectionnée est introuvable dans l'annuaire. Vérifiez la sélection ou réessayez plus tard.",
		FOLDER_SHARING_INVITED_OFFICE_PROVISION_FAILED:
			"Impossible d'enregistrer l'étude IdNot du confrère pour cette invitation. Contactez le support si le problème persiste.",
		FOLDER_SHARING_INVITED_NOTARY_IDNOT_INCOHERENT:
			"L'identifiant IdNot du confrère sélectionné ne correspond pas à son compte LeCoffre. L'invitation n'a pas été envoyée. Resélectionnez-le depuis l'annuaire ou contactez le support.",
		FOLDER_SHARING_INVITED_NOTARY_IDNOT_UNRESOLVED:
			"L'identifiant IdNot du confrère est introuvable dans l'annuaire. L'invitation n'a pas été envoyée. Vérifiez la sélection dans l'annuaire IdNot.",
	},
	notaryOperationApiValidation: {
		NOTARY_REMINDERS_AUTOMATIC_DISABLED:
			"Les relances automatiques sont désactivées. Utilisez l'envoi de relance manuelle pour un client depuis sa fiche.",
		NOTARY_DOCUMENTS_NOTARY_BATCH_NO_FILES: "Aucun fichier sélectionné.",
		NOTARY_DOCUMENTS_NOTARY_BATCH_NO_RECIPIENTS: "Aucun destinataire.",
		NOTARY_DOCUMENTS_NOTARY_BATCH_NO_VALID_DOCUMENTS: "Aucun document valide à créer.",
		NOTARY_ANCHOR_ABANDONED_CERTIFICATE: "Impossible de générer le certificat pour un ancrage abandonné.",
	},
	notaryBadRequestApiValidation: NOTARY_BAD_REQUEST_API_I18N,
} as const;
